import React, { useEffect } from 'react';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { createBrowserHistory } from 'history';

const ApplicationInsightsContext = React.createContext(null);

const browserHistory = createBrowserHistory();
const reactPlugin = new ReactPlugin();
const appInsights = new ApplicationInsights({
  config: {
    connectionString: `InstrumentationKey=${process.env.VITE_APPLICATIONINSIGHTS_INSTRUMENTATIONKEY};IngestionEndpoint=https://westeurope-5.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/`,
    extensions: [reactPlugin],
    extensionConfig: {
      [reactPlugin.identifier]: { history: browserHistory },
    },
  },
});

appInsights.addTelemetryInitializer( (item) => {
  return item.baseData.target.includes(process.env.VITE_PUBLIC_HOST_API);
})

export const ApplicationInsightsProvider = ({ children }) => {
  useEffect(() => {
    appInsights.loadAppInsights();
  }, []);

  return (
    <ApplicationInsightsContext.Provider value={appInsights}>
      {children}
    </ApplicationInsightsContext.Provider>
  );
};
